import classes from "./NewMeetupForm.module.css";
import { useState } from "react";
import Spinner from "react-bootstrap/Spinner";

function NewMeetupForm(props) {
	const [title, setTitle] = useState("");
	const [image, setImage] = useState("");
	const [address, setAddress] = useState("");
	const [description, setDescription] = useState("");
	const [loading, setLoadiing] = useState(false);

	function submitHandler(event) {
		event.preventDefault();
		setLoadiing(true);
		const meetupData = {
			title: title,
			image: image,
			address: address,
			description: description,
			addressLower: address.toLowerCase(),
		};
		props.onAddMeetup(meetupData);
	}

	return (
		<div className={classes.card}>
			<form className={classes.form} onSubmit={submitHandler}>
				<div className={classes.control}>
					<label htmlFor="title"> Title </label>
					<input
						type="text"
						required
						value={title}
						placeholder="Texas"
						id="title"
						onChange={(e) => setTitle(e.target.value)}
					/>
				</div>

				<div className={classes.control}>
					<label htmlFor="image"> Image </label>
					<input
						type="url"
						required
						id="image"
						value={image}
						placeholder="Image Link: https://texasimagelink.png... Make sure the link ends in .jpg or png!!!"
						onChange={(e) => setImage(e.target.value)}
					/>
				</div>

				<div className={classes.control}>
					<label htmlFor="address"> Location </label>
					<input
						type="text"
						required
						id="address"
						value={address}
						placeholder="Texas, USA"
						onChange={(e) => setAddress(e.target.value)}
					/>
				</div>

				<div className={classes.control}>
					<label htmlFor="description"> Description </label>
					<textarea
						id="description"
						required
						rows="2"
						value={description}
						placeholder="Second largest State in the US, by size... "
						style={{ overflow: "hidden" }}
						onChange={(e) => setDescription(e.target.value)}
					/>
				</div>

				<div className={classes.actions}>
					<button disabled={loading}>
						{loading ? (
							<>
								{"Loading "}
								<Spinner
									as="span"
									animation="border"
									size="sm"
									role="status"
									aria-hidden="true"
								/>
							</>
						) : (
							"Upload"
						)}
					</button>
				</div>
			</form>
		</div>
	);
}

export default NewMeetupForm;
